var exports = {
  "yx": "ReviewMenuButton__9e8CKv",
  "dR": "submitTextFull__VMPyTh",
  "_g": "submitTextShort__ip2yEj",
};

module.exports = exports;
